import { render, staticRenderFns } from "./base-dailog.vue?vue&type=template&id=7c484f89&scoped=true"
import script from "./base-dailog.vue?vue&type=script&lang=js"
export * from "./base-dailog.vue?vue&type=script&lang=js"
import style0 from "./base-dailog.vue?vue&type=style&index=0&id=7c484f89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c484f89",
  null
  
)

export default component.exports